<template>
  <section class="section-video">
    <div class="inner">
      <div class="titlewrap">
        <h2 class="title">
          평화를 부르는 <br>'어머니 사랑의 언어' <br><span>캠페인송 싱어롱</span>
        </h2>
      </div>

      <div class="videowrap">
        <!-- <div class="default-img">
          <img src="/images/thumb_video_campaignsong.jpg" alt="" />
        </div> -->
        <div class="video-container" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
useHead({
  script: [{ src: 'https://pic.watv.org/watvplayer/watvPlayer.js?v=1' }],
})

const player = ref<any>(null)

onMounted(async () => {
  while (!(window as any).WatvPlayer) {
    await new Promise(r => setTimeout(r, 100))
  }
  const url = 'https://vod.watv.org/hml/_definst_/mp4:HEAVENLYMOTHERSLOVE/music/campaign_song_251230.mp4/playlist.m3u8'
  player.value = new (window as any).WatvPlayer('.video-container')
  await player.value.load(url)
})

onUnmounted(() => {
  player.value.destroy()
})
</script>
